import { IFlash, IUserSessionData } from './../models/user.model';
import { createAction, props } from '@ngrx/store';

import { AccessToken, UserActions } from '../models/user.model';

export const init = createAction(UserActions.LOGIN_INITIALIZE);

export const initSuccess = createAction(UserActions.LOGIN_INITIALIZE_SUCCESS);

export const login = createAction(
  UserActions.LOGIN_ACTION,
  props<{ username: string; password: string }>(),
);

export const loginRedirectBilling = createAction(
  UserActions.LOGIN_REDIRECT_BILLING,
  props<{ username: string }>(),
);

export const loginRedirectConfirmation = createAction(
  UserActions.LOGIN_REDIRECT_CONFIRMATION,
);

export const loginSuccess = createAction(
  UserActions.LOGIN_ACTION_SUCCESS,
  props<{ accessToken: AccessToken }>(),
);

export const loginFailed = createAction(
  UserActions.LOGIN_ACTION_FAILURE,
  props<{ error: any }>(),
);

export const logout = createAction(UserActions.LOGOUT);

export const logoutSuccess = createAction(UserActions.LOGOUT_SUCCESS);

export const getUserSession = createAction(UserActions.GET_USER_SESSION);

export const setUserSessionData = createAction(
  UserActions.SET_USER_SESSION_DATA,
  props<{ data: IUserSessionData }>(),
);

export const userSessionDataError = createAction(
  UserActions.USER_SESSION_DATA_ERROR,
  props<{ error: any }>(),
);

export const setFlash = createAction(
  UserActions.SET_FLASH,
  props<{ data: IFlash }>(),
);

export const popFlash = createAction(UserActions.POP_FLASH);

export const toggleEmailPreview = createAction(
  UserActions.TOGGLE_EMAIL_PREVIEW,
  props<{ account_id: number; current: boolean }>(),
);

export const toggleEmailPreviewSuccess = createAction(
  UserActions.TOGGLE_EMAIL_PREVIEW_SUCCESS,
  props<{ value: boolean }>(),
);

export const toggleVipFeature = createAction(
  UserActions.TOGGLE_VIP_FEATURE,
  props<{ value: boolean; account_id: number }>(),
);

export const toggleVipFeatureSuccess = createAction(
  UserActions.TOGGLE_VIP_FEATURE_SUCCESS,
  props<{ value: boolean }>(),
);

export const toggleHints = createAction(
  UserActions.TOGGLE_HINTS,
  props<{ account_id: number; value: boolean }>(),
);

export const toggleHintsSuccess = createAction(
  UserActions.TOGGLE_HINTS_SUCCESS,
  props<{ value: boolean }>(),
);

export const toggleUnsubscribe = createAction(
  UserActions.TOGGLE_UNSUBSCRIBE,
  props<{ account_id: number; value: boolean }>(),
);

export const toggleUnsubscribeSuccess = createAction(
  UserActions.TOGGLE_UNSUBSCRIBE_SUCCESS,
  props<{ value: boolean }>(),
);

export const setSignature = createAction(
  UserActions.SET_SIGNATURE,
  props<{ signature: string }>(),
);

export const updateTimezone = createAction(
  UserActions.UPDATE_TIMEZONE,
  props<{ timezone: string }>(),
);

export const vmsMessageLock = createAction(
  UserActions.VSM_MESSAGE_LOCK,
  props<{ messageId: number }>(),
);
